var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.modalId,"hide-footer":"","no-close-on-backdrop":"","size":"lg"}},[_c('div',{staticClass:"privacy-modal-card"},[_c('privacy-notice')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }